import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../api/admin';

import './TablePage.css';

const STATUS_LABELS: Record<string, string> = {
  pending: '대기중',
  delivered: '전달됨',
  viewed: '확인함',
  guessed: '픽 완료',
  awaiting_result: '결과대기',
  matched: '매칭성공',
  failed: '매칭실패',
  expired: '만료',
};

export default function ChainsPage() {
  const [chains, setChains] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const data = await adminApi.getChains(page, 20);
    setChains(data.data);
    setTotal(data.total);
    setTotalPages(data.totalPages);
    setLoading(false);
  }, [page]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="table-page">
      <div className="page-header">
        <h2>체인 모니터링 <span className="count">({total.toLocaleString()})</span></h2>
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>루트 픽</th>
              <th>시작 유저</th>
              <th>힌트</th>
              <th>체인 길이</th>
              <th>루트 상태</th>
              <th>노드 현황</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="center">로딩 중...</td></tr>
            ) : chains.length === 0 ? (
              <tr><td colSpan={6} className="center">체인 데이터 없음</td></tr>
            ) : chains.map((c) => (
              <tr key={c.rootPickId} className="clickable" onClick={() => navigate(`/chains/${c.rootPickId}`)}>
                <td><code>{c.rootPickId.slice(0, 8)}</code></td>
                <td>{c.starterPhone || '-'}</td>
                <td>{c.rootHint || '-'}</td>
                <td><strong>{c.length}</strong></td>
                <td><span className={`badge ${c.rootStatus}`}>{STATUS_LABELS[c.rootStatus] || c.rootStatus}</span></td>
                <td>
                  {c.nodes.map((n: any, i: number) => (
                    <span key={i} className={`badge ${n.status}`} style={{ marginRight: 4, marginBottom: 2 }}>
                      {STATUS_LABELS[n.status]?.[0] || '?'}
                    </span>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>이전</button>
        <span>{page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>다음</button>
      </div>
    </div>
  );
}
